import { apiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BaseResource";
class TableColumnResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.hrefLink = "";
        this.groupLabel = "";
        this.footerGroupLabel = "";
    }
    pk() {
        return this.formTemplateTableColumnId?.toString() || "";
    }
}
TableColumnResource.urlRoot = apiResourceUrl("tableColumn");
export { TableColumnResource };
//# sourceMappingURL=TableColumnResource.js.map